import Api from "./Api";

export default {
  getWalletStatuses() {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}status`;
      Api.get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  checkIfWalletRequestIsAlreadyInitiated(projectId)
  {
    let url= `${process.env.VUE_APP_baseUrl}wallet/checkactivewalletrequest/${projectId}`
    return  Api.get(url);
  },
  getWalletRequests(filter) {
    return new Promise((resolve, reject) => {
     
      let url = `${process.env.VUE_APP_baseUrl}wallet/requests`;
      Api.get(url,{ params: filter })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getWalletRequest(requestId) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}wallet/requests/${requestId}/details`;
      Api.get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createWalletRequest(request) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}wallet/request`;
      Api.post(url, request)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  processWalletRequest(paymentRequestId, details) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}wallet/processrequest/${paymentRequestId}`;
      Api.put(url, details)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  MarkWalletRequestAsPaid(details) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}wallet/markaspaid`;
      Api.put(url, details)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  CheckWalletId(walletId) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}wallet/${walletId}/check`;
      Api.get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  RejectWalletRequest(paymentRequestId, reason) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}wallet/${paymentRequestId}?reason=${reason}`;
      Api.delete(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DownloadAttachment(paymentRequestId, fileName, fileId) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}wallet/download/${paymentRequestId}/${fileName}/${fileId}`;
      Api.get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DownloadOFACLetter(paymentRequestId, id) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}wallet/download/${paymentRequestId}/ofacletter/${id}`;
      Api.get(url, { responseType: "blob" })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GenerateOFACLetter(paymentRequestId) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}wallet/${paymentRequestId}/ofacrequest`;
      Api.post(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  SendApprovalEmail(paymentRequestId) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}wallet/${paymentRequestId}/approvalemail`;
      Api.post(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  SendApprovedEmail(paymentRequestId) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}wallet/${paymentRequestId}/approvedemail`;
      Api.post(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  SendInvoiceEmail(paymentRequestId) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}wallet/${paymentRequestId}/invoiceEmail`;
      Api.post(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateWalletStatus(paymentRequestId, status) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}wallet/${paymentRequestId}/status`;
      Api.put(url, status)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
